var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramPeople64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./People64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pictogram",
    transform: "translate(8.000000, 9.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left",
    transform: "translate(0.000000, 0.235988)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Head",
    cx: 12,
    cy: 7.87692308,
    rx: 8,
    ry: 7.87692308
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,29.5384615 C0,21.9254287 5.372583,15.7538462 12,15.7538462 C18.627417,15.7538462 24,21.9254287 24,29.5384615 L24,43.3230769 L0,43.3230769 L0,29.5384615 Z",
    id: "Body"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(24.000000, 0.235988)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Head",
    fill: "#FFFFFF",
    cx: 12,
    cy: 7.87692308,
    rx: 8,
    ry: 7.87692308
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,29.5384615 C0,21.9254287 5.372583,15.7538462 12,15.7538462 C18.627417,15.7538462 24,21.9254287 24,29.5384615 L24,43.3230769 L0,43.3230769 L0,29.5384615 Z",
    id: "Body",
    fill: "#FFCC00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPeople64);
export default __webpack_public_path__ + "static/media/pictogramPeople64.de85fab9cb5a08846d01964eea263301.svg";
export { ForwardRef as ReactComponent };